export default "__VITE_ASSET__EsoTmDlq__"